/* eslint-disable */

import moment from 'moment';
import axios from 'axios';
import * as firebase from 'firebase/app';
import CryptoService from "@/services//crypto-services";
import RequestHelperService from '@/services//request-helper-service';
const requestHelper = new RequestHelperService();



const cryptoService = new CryptoService();
const remoteURL = process.env.VUE_APP_REMOTE_URL;
// const remoteURL = "http://localhost:6241";
const gatewayURL = process.env.VUE_APP_GATEWAY_URL;
const customerID = process.env.VUE_APP_CUSTOMER_ID;
const configRemoteURL_URL = process.env.VUE_APP_configRemoteURL_URL;
let agrisSessiontID = "";

export default class DataService {

    get AgentInfo() {
        return localStorage.agentInfo ? JSON.parse(localStorage.agentInfo) : null;
    }

    GetPendingBookings(requestType, filterExpiration, getDeleted = false, callback, faildCallback) {
        // console.log(requestType);
        var userData = JSON.parse(localStorage.usertData);
        var agentInfo = JSON.parse(localStorage.agentInfo); var data = {
            Status: "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: requestType,
            AppName: 'myGrower'
        };
        let transactionType = '';
        let expirationQuery = '';
        if (requestType === 'Quotes') {
            transactionType = 'quote';
            requestType = 'pending';
            expirationQuery = `&filterExpiration=${!filterExpiration}&getDeleted=${getDeleted}`;
        } else {
            transactionType = 'book,prepay,order';
            if (requestType === 'declined')
                requestType = 'rejected'
        }
        let isFilterEnable = localStorage.getItem("enablefilter") === 'true' ? true : false;
       
        // axios.get(`${remoteURL}/api/Bookings/${requestType}/${agentInfo.AgentId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${userData.userEmail}/${isFilterEnable}/?transactiontype=${transactionType}${expirationQuery}`)
        // .then(response => {
        //     callback(response.data.TransactionObject);
        // }).catch(e => {
        //     faildCallback(e);
        // })


        requestHelper.Get(`${remoteURL}/api/Bookings/${requestType}/${agentInfo.AgentId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${userData.userEmail}/${isFilterEnable}/?transactiontype=${transactionType}${expirationQuery}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject);
        }).catch(e => {
            faildCallback(e);
        })


    }

    GetPendingBookingsPaginated(requestType, filterExpiration, getDeleted = false, pageNumber, pageSize, sortBy, sortOrder, columnFilters = {}, callback, faildCallback) {
        var userData = JSON.parse(localStorage.usertData);
        var agentInfo = JSON.parse(localStorage.agentInfo); var data = {
            Status: "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: requestType,
            AppName: 'myGrower'
        };
        let transactionType = '';
        let expirationQuery = '';
        if (requestType === 'Quotes') {
            transactionType = 'quote';
            requestType = 'pending';
            expirationQuery = `&filterExpiration=${!filterExpiration}&getDeleted=${getDeleted}`;
        } else {
            transactionType = 'book,prepay,order';
            if (requestType === 'declined')
                requestType = 'rejected'
        }
        let isFilterEnable = localStorage.getItem("enablefilter") === 'true' ? true : false;

        const filterQuery = Object.entries(columnFilters)
            .map(([col, val]) => `&col_${encodeURIComponent(col)}=${encodeURIComponent(val as string)}`)
            .join('');

        requestHelper.Get(`${remoteURL}/api/Bookings/${requestType}-paginated/${agentInfo.AgentId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${userData.userEmail}/${isFilterEnable}?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&transactiontype=${transactionType}${expirationQuery}${filterQuery}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject.Items, response.data.TransactionObject.TotalRecords);
        }).catch(e => {
            faildCallback(e);
        })


    }
    GetBookingItems(bookingId, location, callback, faildCallback) {
        var agentInfo = JSON.parse(localStorage.agentInfo); var data = {
            Status: "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            AppName: 'myGrower'
        };

        // axios.get(`${remoteURL}/api/Bookings/bookingItems/${bookingId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${location}`)
        // .then(response => {
        //     callback(response.data.TransactionObject);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(`${remoteURL}/api/Bookings/bookingItems/${bookingId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${location}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject);
        }).catch(e => {
            faildCallback(e);
        })

    }
    getBookingItemLocation(bookingId, itemId, element, callback, faildCallback) {
        // axios.get(`${remoteURL}/api/Bookings/bookingItemLocation/${bookingId}/${itemId}`)
        // .then(response => {
        //     callback(element, response.data.TransactionMessage);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(`${remoteURL}/api/Bookings/bookingItemLocation/${bookingId}/${itemId}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(element, response.data.TransactionMessage);
        }).catch(e => {
            faildCallback(e);
        })
    }
    getBookingOverview(transactionType, callback, faildCallback) {
        var agentInfo = JSON.parse(localStorage.agentInfo);
        var userData = JSON.parse(localStorage.usertData);
        var data = {
            Status: "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            AppName: 'myGrower'
        };
        let expirationQuery = '';
        if (transactionType === 'quote') expirationQuery = '&filterExpiration=true';
        let isFilterEnable = localStorage.getItem("enablefilter") === 'true' ? true : false;
        // axios.get(`${remoteURL}/api/bookings/overview/${agentInfo.AgentId}/${agentInfo.TenantId}/${userData.userEmail}/${isFilterEnable}/?transactiontype=${transactionType}${expirationQuery}`)
        // .then(response => {
        //     callback(response.data.TransactionObject);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(`${remoteURL}/api/bookings/overview/${agentInfo.AgentId}/${agentInfo.TenantId}/${userData.userEmail}/${isFilterEnable}/?transactiontype=${transactionType}${expirationQuery}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject);
        }).catch(e => {
            faildCallback(e);
        })

    }
    GetOrderRemarks(bookingId, callback, faildCallback) {
        // axios.get(`${remoteURL}/api/Bookings/orderRemarks/${bookingId}`)
        // .then(response => {
        //     callback(response.data.TransactionObject);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(`${remoteURL}/api/Bookings/orderRemarks/${bookingId}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject);
        }).catch(e => {
            faildCallback(e);
        })
    }
    connect(userEmail, password): Promise<any> {

        var data = { AgentEmail: userEmail, EncryptedPassword: cryptoService.encryptString(password) };

        // Convert to string
        var dataString = JSON.stringify(data);

        // Now you can encrypt dataString
        var encryptedData = { EncryptedData: cryptoService.encryptString(dataString) };

        var promise = new Promise(function (resolve, reject) {
            requestHelper.Post(`${remoteURL}/api/passthrough/GetAgentDataSets`, encryptedData, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false).then(response => {
                console.log(response.data);
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    }
    login(userEmail, password, sessionID, tenantId): Promise<any> {
        var data = {
            SessionID: sessionID,
            TenantId: tenantId,
            UserID: userEmail,
            AgrisSessionId: "",
            Password: cryptoService.encryptString(password)
        };

        // Convert to string
        var dataString = JSON.stringify(data);

        // Now you can encrypt dataString
        var encryptedData = { EncryptedData: cryptoService.encryptString(dataString) };

        var promise = new Promise(function (resolve, reject) {
            requestHelper.Post(`${remoteURL}/api/Login/ValidateCredentials`, encryptedData, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false).then(response => {
                agrisSessiontID = response.data.Message
                console.log(response.data);
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    }
   logout(userEmail, password, sessionID, tenantId): Promise<any> {

         let promise =   this.logoutAgris(userEmail, password, tenantId);
        return promise;
    }
    logoutAgris(userEmail, password, tenantId): Promise<any> {

        var promise = new Promise(function (resolve, reject) {

            var agentInfo = JSON.parse(localStorage.agentInfo);

            let body = {
                "TenantID": tenantId,
                "UserID": userEmail,
                "Password": password,
                "ExtendedOption": "nko",
                "ExtendedOptionValue": "NAM12",
                "SessionID": agentInfo.SessionID,
                "AgrisSession": agrisSessiontID
            }
            
            requestHelper.Post(`${remoteURL}/api/AgrisLicense/ReleaseLicense`, body, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data.TransactionObject);
                }).catch(e => {
                    reject(e);
                })
        });

        return promise;
    }
    getActionsListRequestCount(status, agentId, tenantId, callback): Promise<any> {
        return new Promise(function (resolve, reject) {
            var data = {
                Status: status,
                AgentId: agentId,
                TenantId: tenantId
            };
           
            // requestHelper.PostCommand(`${remoteURL}/api/ActionListReview/GetReviewRequestCount`, data)
            // .then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/ActionListReview/GetReviewRequestCount`,data, undefined, undefined,tenantId,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });

        });
    }
    updateBooking(booking, callback, faildCallback) {
      
        // axios.post(`${remoteURL}/api/Bookings/update`, booking)
        // .then(response => {
        //     callback(response.data.TransactionObject);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Post(`${remoteURL}/api/Bookings/update`,booking, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data.TransactionObject);
        }).catch(e => {
            faildCallback(e);
        })
    }
    approveBooking(booking, callback, faildCallback) {
       
        // axios.post(`${remoteURL}/api/Bookings/approvebooking`, booking)
        // .then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Post(`${remoteURL}/api/Bookings/approvebooking`,booking, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            faildCallback(e);
        })
    }
    approveTransaction(request, callback, faildCallback) {
        
        this.ValidateAgentSession().then(() => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            request.SessionId = agentInfo.SessionID;
            
            // axios.post(`${remoteURL}/api/Bookings/approvetransaction`, request)
            // .then(response => {
            //     callback(response.data);
            // }).catch(e => {
            //     faildCallback(e);
            // });

            requestHelper.Post(`${remoteURL}/api/Bookings/approvetransaction`,request, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                callback(response.data);
            }).catch(e => {
                faildCallback(e);
            });
        })
    }
    declineTransaction(request, callback, faildCallback) {
      
        this.ValidateAgentSession().then(() => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            request.SessionId = agentInfo.SessionID;
          
            // axios.post(`${remoteURL}/api/Bookings/declinetransaction`, request)
            // .then(response => {
            //     callback(response.data);
            // }).catch(e => {
            //     faildCallback(e);
            // });

            requestHelper.Post(`${remoteURL}/api/Bookings/declinetransaction`,request, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                callback(response.data);
            }).catch(e => {
                faildCallback(e);
            });
        });

    }
    markVoidAndApproveBooking(booking) {
        
        return new Promise((resolve, reject) => {
           
            // axios.post(`${remoteURL}/api/Bookings/approvebooking`, booking)
            // .then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Bookings/approvebooking`,booking, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    printTransaction(booking) {
        return new Promise(function (resolve, reject) {

            // axios.post(`${remoteURL}/api/Bookings/print`, booking)
            // .then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Bookings/print`,booking, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    declineBooking(booking, callback, faildCallback) {
        let url = "";
        // // if(booking.Status)
        // //     url=`${remoteURL}/api/Bookings/rejectbooking/${booking.Id}/${booking.User}/${booking.Status}`;            
        // // else 
        // url = `${remoteURL}/api/Bookings/rejectbooking/${booking.Id}/${booking.User}`;
        // axios.get(url)
        // .then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(url,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            faildCallback(e);
        })

    }
    deleteBooking(booking, callback, faildCallback) {
        let url = "";
        // // if(booking.Status)
        // //     url=`${remoteURL}/api/Bookings/rejectbooking/${booking.Id}/${booking.User}/${booking.Status}`;            
        // // else 
        // url = `${remoteURL}/api/Bookings/softdeleteBooking/${booking.Id}/${booking.User}`;
        // axios.get(url).then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     faildCallback(e);
        // })

        requestHelper.Get(url,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            faildCallback(e);
        })
    }
    doneRequest(requestId, userId, message, callback) {
        var data = {
            ReviewRequestId: requestId,
            UserId: userId,
            Message: message
        };

        // requestHelper.PostCommand(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusApproved`, data)
        // .then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     callback(false);
        //     console.log(e);
        // })

        requestHelper.Post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusApproved`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            callback(false);
            console.log(e);
        });

    }
    declineRequest(requestId, userId, message, callback) {
        var data = {
            ReviewRequestId: requestId,
            UserId: userId,
            Message: message
        };
        // requestHelper.PostCommand(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusRejected`, data)
        // .then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     callback(false);
        //     console.log(e);
        // })

        requestHelper.Post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusRejected`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            callback(false);
            console.log(e);
        });
    }
    sendMessage(userId, title, message, requestAgrisNameAddressID, requestSQLID) {
        var title = title;
        //var body = "<a href='#/portal/grower/scaleticket/'" + requestAgrisNameAddressID + '/' + requestSQLID + ">" + message + "</a>";
        var body = message; // + [requestAgrisNameAddressID] + [requestSQLID];
        var to = "/topics/" + userId;

        var notificationInfo = {
            "notification": {
                "title": title,
                "body": body,
                "sound": "default",
                "click_action": "/#/portal/grower/newslist",
                "icon": "fcm_push_icon"
            },
            "data": {
                "param1": "value1",
                "param2": "value2"
            },
            "to": to,
            "priority": "high",
            "restricted_package_name": ""
        }

        var pushNotificationMessage = JSON.stringify(notificationInfo);
        var xhr = new XMLHttpRequest();
        var url = "https://fcm.googleapis.com/fcm/send";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Authorization", "key=AAAAx9mdR5E:APA91bETg3x7jPgsCaNOSJR0XLk6eWvnnht9nJYzVStvy8jN0OMKHO6TVgUSh-yE47g-rAKA0rJi3o0CFJKJCHUelx0ODltKyFkMHCrs6x50ULqwV0W2rXpTNm2v-s9c8fpSr2CtMLzz");
        xhr.send(pushNotificationMessage);

        var data = {
            title: title,
            message: message,
            email: userId,
        }
        this.insertDataIntoFirebase(data);
    }
    insertDataIntoFirebase(data) {
        var config = {
            apiKey: "AAAAx9mdR5E:APA91bETg3x7jPgsCaNOSJR0XLk6eWvnnht9nJYzVStvy8jN0OMKHO6TVgUSh-yE47g-rAKA0rJi3o0CFJKJCHUelx0ODltKyFkMHCrs6x50ULqwV0W2rXpTNm2v-s9c8fpSr2CtMLzz",
            authDomain: "mygrowermobileclient.firebaseapp.com",
            databaseURL: "https://mygrowermobileclient.firebaseio.com",
            projectId: "mygrowermobileclient",
            storageBucket: "mygrowermobileclient.appspot.com",
        };
        if (!firebase.apps.length) {
            firebase.initializeApp(config);
        }
        var database = firebase.database();
        database.ref('notifications').set({
            title: data.title,
            message: data.message,
            email: data.email,
            showpopup: 'YES'
        }, (error) => {
            if (error) {
                console.log(error);
            } else {
                // Data saved successfully!
            }
        });
    }
    getAgentVersion(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().finally(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
               
                // axios.get(`${remoteURL}/api/Passthrough/GetSystemInfo?SessionID=${agentInfo.SessionID}`)
                // .then(response => {
                //     resolve(response.data);
                // }).catch((e) => {
                //     reject(e);
                // });

                requestHelper.Get(`${remoteURL}/api/Passthrough/GetSystemInfo?SessionID=${agentInfo.SessionID}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
                .then(response => {
                    resolve(response.data);
                }).catch((e) => {
                    reject(e);
                });
            })
        });
    }
    ValidateAgentSession(): Promise<any> {

        let date = moment.utc(Date.now()).local();
        let formateddate = date.format("MM/DD/YYYY hh:mm A");
        let AgentSessionTime = localStorage.getItem("AgentSessionUpdateTime");


        if (AgentSessionTime) {
            let AgentSessionToDate = new Date(AgentSessionTime)
            let CurrentTimeStringToDate = new Date(formateddate)

            if (CurrentTimeStringToDate > AgentSessionToDate) {
                let _30minAddinTime = moment(CurrentTimeStringToDate).add(30, 'm');
                let _30minFormatedDate = _30minAddinTime.format("MM/DD/YYYY hh:mm A")

                return new Promise((resolve, reject) => {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        SessionID: agentInfo.SessionID,
                        'Content-Type': 'application/json'
                    };
                    axios.get(`${gatewayURL}/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/Version`, { headers }).then((response) => {
                        if (response.data.System) {
                            localStorage.setItem("AgrisVersion", JSON.parse(decodeURI(response.data.System)).Version);
                        }

                        localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
                        resolve(true);
                    }).catch((e) => {
                        if (e.response.data.Code == 401) {
                            requestHelper.GetAgentSessionId().then((newSessionId) => {
                                localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
                                resolve(true);
                            });
                        }
                    });
                });

            } else {
                return new Promise((resolve, reject) => { resolve(true); })
            }
        }
        else {
            let _30minAddinTime = moment(date).add(30, 'm');
            let _30minFormatedDate = _30minAddinTime.format("MM/DD/YYYY hh:mm A")
            localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
            return new Promise((resolve, reject) => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var headers = {
                    SessionID: agentInfo.SessionID,
                    'Content-Type': 'application/json'
                };
                axios.get(`${gatewayURL}/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/Version`, { headers }).then((response) => {
                    resolve(true);
                }).catch((e) => {
                    if (e.response.data.Code == 401) {
                        requestHelper.GetAgentSessionId().then((newSessionId) => {
                            resolve(true);
                        });
                    }
                });
            });
        }




    }
    getLocations(itemNumbers, callback, failedCallback) {
        var agentInfo = JSON.parse(localStorage.agentInfo);

        var data = {
            SessionID: agentInfo.SessionID,
            TenantId: agentInfo.TenantId,
            ItemNumbers: itemNumbers
        };

        // axios.post(`${remoteURL}/api/Passthrough/GetLocations`, data)
        // .then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     failedCallback(e);
        // });

        requestHelper.Post(`${remoteURL}/api/Passthrough/GetLocations`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
        .then(response => {
            callback(response.data);
        }).catch(e => {
            failedCallback(e);
        });

    }
    getAgrisDateRange(type): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var headers = {
                AgentId: agentInfo.AgentId
            };
            // axios.get(`${remoteURL}/api/Passthrough/ProcessingDate/${agentInfo.SessionID}/${agentInfo.TenantId}/ACR/${type.toUpperCase()}`,
            //     { headers: headers }
            // ).then((response: any) => {
            //     resolve(response.data.ResultObject);
            // }).catch(e => {
            //     reject(e);
            // });

            requestHelper.Get(`${remoteURL}/api/Passthrough/ProcessingDate/${agentInfo.SessionID}/${agentInfo.TenantId}/ACR/${type.toUpperCase()}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false,headers)
            .then((response: any) => {
                resolve(response.data.ResultObject);
            }).catch(e => {
                reject(e);
            });

        });

        return promise;
    }
    getAgrisDecimalPricision(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);

            // axios.get(`${remoteURL}/api/Passthrough/AgrisPrecision/${agentInfo.SessionID}/${agentInfo.TenantId}`)
            // .then((response: any) => {
            //     if (response.data.ResultObject && response.data.ResultObject.length > 0) {
            //         resolve(response.data.ResultObject[0]);
            //     } else {
            //         reject({
            //             Message: "No records found"
            //         });
            //     }
            // }).catch(e => {
            //     reject(e);
            // });

            requestHelper.Get(`${remoteURL}/api/Passthrough/AgrisPrecision/${agentInfo.SessionID}/${agentInfo.TenantId}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then((response: any) => {
                if (response.data.ResultObject && response.data.ResultObject.length > 0) {
                    resolve(response.data.ResultObject[0]);
                } else {
                    reject({
                        Message: "No records found"
                    });
                }
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    }
    SetUserPrefrences(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var userData = JSON.parse(localStorage.usertData);
                var data = {
                    agentId: agentInfo.AgentId,
                    tenantId: agentInfo.TenantId,
                    sessionId: agentInfo.SessionID,
                    userId: userData.userEmail,
                    password: null
                };
                // axios.post(`${remoteURL}/api/Settings/SetUserPrefrences`, data)
                // .then(response => {
                //     let date = new Date();
                //     let refreshTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                //     localStorage.setItem("UserRefreshTime", refreshTime);
                //     resolve(response);
                // }).catch(e => {
                //     reject(e);
                // })

                requestHelper.Post(`${remoteURL}/api/Settings/SetUserPrefrences`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
                .then(response => {
                    let date = new Date();
                    let refreshTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                    localStorage.setItem("UserRefreshTime", refreshTime);
                    resolve(response);
                }).catch(e => {
                    reject(e);
                })

            })
        })
    }
    GetUserPrefrences(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var userData = JSON.parse(localStorage.usertData);
                var data = {
                    agentId: agentInfo.AgentId,
                    tenantId: agentInfo.TenantId,
                    sessionId: agentInfo.SessionID,
                    userId: userData.userEmail,
                    password: null
                };
                // axios.post(`${remoteURL}/api/Settings/GetUserPrefrences`, data)
                // .then(response => {
                //     if (!response.data.TransactionObject) {
                //         reject(response.data.ErrorMessage);
                //     }
                //     let users = response.data.TransactionObject;
                //     console.log(users);
                //     resolve(users);
                // }).catch(e => {
                //     reject(e);
                // })

                requestHelper.Post(`${remoteURL}/api/Settings/GetUserPrefrences`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
                .then(response => {
                    if (!response.data.TransactionObject) {
                        reject(response.data.ErrorMessage);
                    }
                    let users = response.data.TransactionObject;
                    console.log(users);
                    resolve(users);
                }).catch(e => {
                    reject(e);
                })
            })
        });
        return promise;
    }
    SetOrderRemarksConfiguration(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var data = {
                    agentId: agentInfo.AgentId,
                    tenantId: agentInfo.TenantId,
                    sessionId: agentInfo.SessionID,
                    password: null
                };
                // axios.post(`${remoteURL}/api/OrderRemarksConfig/SyncFromAgris`, data)
                // .then(response => {
                //     let date = new Date();
                //     let refreshTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                //     localStorage.setItem("SalesOrderRemarksConfiguratinRefreshTime", refreshTime);
                //     resolve(response);
                // }).catch(e => {
                //     reject(e);
                // });

                requestHelper.Post(`${remoteURL}/api/OrderRemarksConfig/SyncFromAgris`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
                .then(response => {
                    let date = new Date();
                    let refreshTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                    localStorage.setItem("SalesOrderRemarksConfiguratinRefreshTime", refreshTime);
                    resolve(response);
                }).catch(e => {
                    reject(e);
                });
            });
        })
    }
    GetOrderRemarksConfiguration(): Promise<any> {
        let promise = new Promise((resolve, reject) => {

            var agentInfo = JSON.parse(localStorage.agentInfo);
            var userData = JSON.parse(localStorage.usertData);
            var data = {
                agentId: agentInfo.AgentId,
                tenantId: agentInfo.TenantId,
            };
            // axios.get(`${remoteURL}/api/OrderRemarksConfig/Config/${agentInfo.TenantId}`)
            // .then(response => {
            //     if (!response.data.TransactionObject) {
            //         reject(response.data.ErrorMessage);
            //     }
            //     let configuration = response.data.TransactionObject;
            //     console.log(configuration);
            //     resolve(configuration);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Get(`${remoteURL}/api/OrderRemarksConfig/Config/${agentInfo.TenantId}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                if (!response.data.TransactionObject) {
                    reject(response.data.ErrorMessage);
                }
                let configuration = response.data.TransactionObject;
                console.log(configuration);
                resolve(configuration);
            }).catch(e => {
                reject(e);
            });

        });
        return promise;
    }
    UpdateOrderRemarksConfiguration(users): Promise<any> {
        return new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
           
            // axios.post(`${remoteURL}/api/OrderRemarksConfig/SaveConfig/${agentInfo.TenantId}`, users)
            // .then(response => {
            //     resolve(response);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/OrderRemarksConfig/SaveConfig/${agentInfo.TenantId}`,users, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        })
    }
    UpdateUserPrefrences(users): Promise<any> {
        return new Promise((resolve, reject) => {

            // axios.post(`${remoteURL}/api/Settings/UpdateUserPrefrences`, users)
            // .then(response => {
            //     resolve(response);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Settings/UpdateUserPrefrences`,users, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        })
    }
    GetSignatureByBookingId(bookingId): Promise<any> {
        return new Promise((resolve, reject) => {
            // axios.get(`${remoteURL}/api/Bookings/signatureByBookingId/${bookingId}`)
            // .then(response => {
            //     resolve(response.data.TransactionObject);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Get(`${remoteURL}/api/Bookings/signatureByBookingId/${bookingId}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response.data.TransactionObject);
            }).catch(e => {
                reject(e);
            });
        });
    }
    public GetBankCodes(): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem("AgentType");
            if (agentTypefromLocal) {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var headers = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: ''
                };
                let url = `${gatewayURL}/RESTActivityWebService/agris.relational/BankCode?Where=(<<BankCode.CurrencyCode>> eq ? or <<BankCode.CurrencyCode>> ne ?)&param0&param1`;
                if (agentTypefromLocal == 'SQL') {
                    headers.Options = 'CrossTenantQuery|true';
                    url = `${gatewayURL}/RESTActivityWebService/agris.relational/BankCode?Where=<<BankCode.TenantID>> eq ? and (<<BankCode.CurrencyCode>> eq ? or <<BankCode.CurrencyCode>> ne ?) &param0=${agentInfo.TenantId}&param1&param2`
                }
                axios.get(url, { headers }).then((response) => {
                    resolve(response.data);
                }, (error) => {
                    reject(error.error);
                })
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType.AgentType);
                    resolve(this.GetBankCodes());
                })
            }
        });
    }
    public getAgentType(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var headers = {
                    tenantId: agentInfo.TenantId,
                    sessionId: agentInfo.SessionID,
                };
                axios.get(`${gatewayURL}/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetFilesInfo`, { headers }).then((response) => {
                    resolve(response.data);
                }, (error) => {
                    reject(error.error);
                })
            })
        });
    }
    GetUserPermissions(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var userData = JSON.parse(localStorage.usertData);
                var data = {
                    agentId: agentInfo.AgentId,
                    tenantId: agentInfo.TenantId,
                    sessionId: agentInfo.SessionID,
                    userId: userData.userEmail,
                    password: null
                };
                // axios.post(`${remoteURL}/api/Settings/GetUserPermissions`, data)
                // .then(response => {
                //     if (!response.data.TransactionObject) {
                //         reject(response.data.ErrorMessage);
                //     }
                //     let users = response.data.TransactionObject;
                //     console.log(users);
                //     resolve(users);
                // }).catch(e => {
                //     reject(e);
                // })


                requestHelper.Post(`${remoteURL}/api/Settings/GetUserPermissions`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
                .then(response => {
                    if (!response.data.TransactionObject) {
                        reject(response.data.ErrorMessage);
                    }
                    let users = response.data.TransactionObject;
                    console.log(users);
                    resolve(users);
                }).catch(e => {
                    reject(e);
                });

            })
        });
        return promise;
    }
    UpdateUserPermissions(users): Promise<any> {
        return new Promise((resolve, reject) => {
            // axios.post(`${remoteURL}/api/Settings/UpdateUserPermissions`, users)
            // .then(response => {
            //     resolve(response);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Settings/UpdateUserPermissions`,users, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        })        
    }
    getAgeisUserPermissions(userId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var headers = {
                    SessionID: agentInfo.SessionID,
                    'Content-Type': 'application/json'
                };
                let url = `${gatewayURL}/RESTCommandWebService/ExecuteServerCommand/SecurityProcessor/GetEffectivePermissions?TenantID=${agentInfo.TenantId}&UserID=${userId}&Package=ACR,INV&SecurityOption=KIMPT,RIMPT,PIMPT,OVRMM&IgnoreSecurityLevels=true`;
                axios.post(url, { CustomerID: customerID }, { headers: headers }).then((permissions) => {
                    resolve(permissions.data);
                }).catch(e => {
                    reject(e);
                })
            })
        })
    }
    GetPackageSetupToken(packageCode): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                let agentTypefromLocal = localStorage.getItem("AgentType");
                if (agentTypefromLocal) {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${gatewayURL}/RESTActivityWebService/agris.relational/PackageSetupToken?PackageCode=${packageCode}`;
                    if (agentTypefromLocal == 'SQL') {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${gatewayURL}/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.TenantID>> eq ? and <<PackageSetupToken.PackageCode>> eq ? &param0=${agentInfo.TenantId}&param1=${packageCode}`
                    }
                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.GetPackageSetupToken(packageCode));
                    })
                }
            });
        });
    }
    GetAppSettings(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var userData = JSON.parse(localStorage.usertData);
            var data = {
                agentId: agentInfo.AgentId,
                tenantId: agentInfo.TenantId,
                sessionId: agentInfo.SessionID,
                userId: userData.userEmail,
                password: null
            };
            // axios.get(`${remoteURL}/api/Settings/GetAppSettings`)
            // .then(response => {
            //     if (!response.data.TransactionObject) {
            //         reject(response.data.ErrorMessage);
            //     }
            //     let users = response.data.TransactionObject;
            //     console.log(users);
            //     resolve(users);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Get(`${remoteURL}/api/Settings/GetAppSettings`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                if (!response.data.TransactionObject) {
                    reject(response.data.ErrorMessage);
                }
                let users = response.data.TransactionObject;
                console.log(users);
                resolve(users);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
    GetAppSettingsByType(type): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var userData = JSON.parse(localStorage.usertData);
            var data = {
                AgentId: agentInfo.AgentId,
                TenantId: agentInfo.TenantId,
                SessionId: agentInfo.SessionID,
                Type: type,
                // Name: ''
            };

            // axios.post(`${remoteURL}/api/Settings/GetAppSettings`, data)
            // .then(response => {
            //     if (!response.data.TransactionObject) {
            //         reject(response.data.ErrorMessage);
            //     }
            //     let data = response.data.TransactionObject;
            //     // console.log(data);
            //     resolve(data);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Settings/GetAppSettings`,data, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                if (!response.data.TransactionObject) {
                    reject(response.data.ErrorMessage);
                }
                let data = response.data.TransactionObject;
                // console.log(data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
    SaveAppSettings(settings): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var userData = JSON.parse(localStorage.usertData);
            settings.forEach(item => {
                item.AgentId = agentInfo.AgentId;
                item.TenantId = agentInfo.TenantId;
                item.UserId = userData.userEmail;
                item.CreatedBy = userData.userEmail;
            });

            // axios.post(`${remoteURL}/api/Settings/SaveAppSettings`, settings)
            // .then(response => {
            //     if (!response.data.TransactionObject) {
            //         reject(response.data.ErrorMessage);
            //     }
            //     let users = response.data.TransactionObject;
            //     console.log(users);
            //     resolve(users);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Post(`${remoteURL}/api/Settings/SaveAppSettings`,settings, undefined, undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                if (!response.data.TransactionObject) {
                    reject(response.data.ErrorMessage);
                }
                let users = response.data.TransactionObject;
                console.log(users);
                resolve(users);
            }).catch(e => {
                reject(e);
            });


        });
        return promise;
    }
    DeleteAppSettingById(Id): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            var agentInfo = JSON.parse(localStorage.agentInfo);
            var userData = JSON.parse(localStorage.usertData);
            var data = {
                agentId: agentInfo.AgentId,
                tenantId: agentInfo.TenantId,
                sessionId: agentInfo.SessionID,
                userId: userData.userEmail,
                password: null
            };
            // axios.get(`${remoteURL}/api/Settings/DeleteAppSettingById/${Id}`)
            // .then(response => {
            //     if (!response.data.TransactionObject) {
            //         reject(response.data.ErrorMessage);
            //     }
            //     let users = response.data.TransactionObject;
            //     console.log(users);
            //     resolve(users);
            // }).catch(e => {
            //     reject(e);
            // })

            requestHelper.Get(`${remoteURL}/api/Settings/DeleteAppSettingById/${Id}`,undefined,undefined,undefined,undefined,undefined,undefined,undefined,false,false,false,false)
            .then(response => {
                if (!response.data.TransactionObject) {
                    reject(response.data.ErrorMessage);
                }
                let users = response.data.TransactionObject;
                console.log(users);
                resolve(users);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
    GetEmailTypesFromAgris(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                let agentTypefromLocal = localStorage.getItem("AgentType");
                if (agentTypefromLocal) {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${gatewayURL}/RESTActivityWebService/agris.relational/ContactTypes?Where= <<ContactTypes.ContactCategory>> eq ?&param0=E`;
                    if (agentTypefromLocal == 'SQL') {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${gatewayURL}/RESTActivityWebService/agris.relational/ContactType?param1=${agentInfo.TenantId}&Where= <<ContactType.ContactCategory>> eq ? and  <<ContactType.TenantID>> eq ?&param0=E`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.GetEmailTypesFromAgris());
                    })
                }
            });
        });
    }

    GetProductCategoryFromAgris(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                let agentTypefromLocal = localStorage.getItem("AgentType");
                if (agentTypefromLocal) {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${gatewayURL}/RESTActivityWebService/agris.relational/ProductCategory`;
                    if (agentTypefromLocal == 'SQL') {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${gatewayURL}/RESTActivityWebService/agris.relational/ProductCategory?Where= <<ProductCategory.TenantID>> eq '${agentInfo.TenantId}'`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.GetEmailTypesFromAgris());
                    })
                }
            });
        });
    }
    GetProductsFromAgris(Ids: [], location): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem("AgentType");
            if (agentTypefromLocal) {
                var agentInfo = JSON.parse(localStorage.agentInfo);
                var headers = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: ''
                };
                let params = [];
                agentTypefromLocal == 'SQL' && agentInfo.TenantId ? params.push(`<<InventoryItem.TenantID>> eq '${agentInfo.TenantId}'`) : '';

                params.push(`<<InventoryItem.InventoryLocation>> eq '${location}'`);
                let url = `${gatewayURL}/RESTActivityWebService/agris.relational/InventoryItem?where=`;
                if (agentTypefromLocal == 'SQL') {
                    headers.Options = 'CrossTenantQuery|true';
                }
                params.forEach((param, i) => {
                    url = `${url}${(i > 0) ? ' AND ' : ''}${param}`
                });
                url = url + ' AND (';
                let ORParams = [];

                Ids.forEach((id) => {
                    if (id)
                        ORParams.push(`<<InventoryItem.ItemNumber>> eq '${id}'`);
                });

                ORParams.forEach((param, i) => {
                    url = `${url}${(i > 0) ? ' OR ' : ''}${param}`
                });
                url = url + ' )';

                axios.get(url, { headers }).then((response) => {
                    resolve(response.data);
                }, (error) => {
                    reject(error);
                })
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType.AgentType);
                    resolve(this.GetEmailTypesFromAgris());
                })
            }
        });
    }



    getAllAgentsDescFromAL(SessionID): Promise<any> {
        // let logMessage = `SessionID: ${SessionID}`;
        // SentryService.logMessage(logMessage, "Getting get All Agents Desc From AL");


        var promise = new Promise(function (resolve, reject) {
            // axios.get(`${configRemoteURL}/api/Modules `, { headers: data }).then(response => {
            //     resolve(response.data);


            requestHelper.Get(`${remoteURL}/api/Bookings/GetAllAgentName`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false).then(response => {
                // console.log(response.data);
                resolve(response.data);
            }).catch(e => {
                // SentryService.logMessage(e, "connect");
                reject(e);
            });
        });

        return promise;
    }
    public getBooking(bookingNumber: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then(() => {
                let agentTypefromLocal = localStorage.getItem("AgentType");
                if (agentTypefromLocal) {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${gatewayURL}/RESTActivityWebService/agris.relational/Bookings?Where=<<Bookings.BookingNumber>> eq '${bookingNumber}'`;
                    if (agentTypefromLocal == 'SQL') {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${gatewayURL}/RESTActivityWebService/agris.relational/Bookings?Where=<<Bookings.BookingNumber>> eq '${bookingNumber}' and <<Bookings.TenantID>> eq '${agentInfo.TenantId}'`;
                    }
                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getBooking(bookingNumber));
                    })
                }
            });
        });
    }
    changeVoidBookingStatus(bookingId, isVoidFailed): Promise<any> {
        var promise = new Promise(function (resolve, reject) {
            requestHelper.Get(`${remoteURL}/api/Bookings/ChangeVoidBookingStatus/${bookingId}/${isVoidFailed}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false).then(response => {
                console.log(response.data);
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }




    getSalesProConfigurations(): Promise<any> {

        let configRemoteURL = configRemoteURL_URL;
        return new Promise((resolve, reject) => {
            this.getModules().then(response => {
                let moduleName = "Sales_Pro";

                let moduleId = response.find(x => x.ModuleName == moduleName).ModuleId;

                // let TenantID  = JSON.parse(localStorage.getItem('dataSet')).TenantID;
                var agentInfo = JSON.parse(localStorage.agentInfo);
                let agentId = agentInfo.AgentId;
                var headers = { Authorization: 'Basic YWRtaW46cGFzc3dvcmQx', };
                let url = `${configRemoteURL}/api/ModuleConfigurations?ModuleId=${moduleId}`;
                if (agentId) { url += `&Agent=${agentId}`; }

                requestHelper.Get(url, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, headers)
                    .then((response: any) => {
                        if (response.data) {
                            let value = JSON.parse(response.data[0].ConfigurationValue);
                            let remark = value && value.Selected ? "true" : "false";
                            // let remark = JSON.parse(response.data[0].ConfigurationValue).Selected;
                            localStorage.setItem("ProUser", cryptoService.encryptString(remark));

                        }

                        resolve(response.data);


                    }, (error) => {
                        if (error && error.status == 0) {
                            // this.events.publish("event:ShowError", "Please check your network and try again.")
                        }
                        else { reject(error); }
                    }
                    );
            });
        });
    };



    getModules(): Promise<any> {


        return new Promise((resolve, reject) => {
            let configRemoteURL = configRemoteURL_URL;
            var headers = { Authorization: 'Basic YWRtaW46cGFzc3dvcmQx', };
            let url = `${configRemoteURL}/api/Modules`;
            requestHelper.Get(url, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, headers)
                .then((response) => {
                    // console.log("test", response.data);
                    resolve(response.data);
                }).catch(e => {
                    reject(e);
                })

        });
    };


    getPdfFromURL(url): Promise<any> {
        return new Promise((resolve, reject) => {

            axios.get(url, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                'responseType': 'blob' // responseType is a sibling of headers, not a child
            })
                .then(response => {
                    if (response.status == 200) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'download.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                .catch(error => {
                    console.log(error);
                })


        });

    };

    DownloadprintTransaction(bookingID: string, isPending, BookingNumber: string) {


        let pdfLink = `${remoteURL}/api/Bookings/GetPrintForm?id=${cryptoService.encryptString(String(bookingID))}&isPending=${isPending}`;
        pdfLink = pdfLink.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);

        return new Promise((resolve, reject) => {
            const headers = {
                'Content-Type': 'multipart/form-data',
            };

            axios.get(pdfLink, {
                headers: headers,
                'responseType': 'blob'
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', BookingNumber + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                }).catch(e => {
                    console.log(JSON.stringify(e))
                    reject(e);
                })
        });
    }



    public getDocumentAttachmentInfo(bookingNumber: string, LocationNumber: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this.ValidateAgentSession().then((sessionID) => {
                let agentTypefromLocal = localStorage.getItem("AgentType");
                if (agentTypefromLocal) {
                    var agentInfo = JSON.parse(localStorage.agentInfo);
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: 'TopN|1|DocumentAttachment.OrderBy|Order By <<DocumentAttachment.AddDateTime>>'
                    };
                    let url = `${gatewayURL}/RESTActivityWebService/agris.relational/DocumentAttachment?where=( <<DocumentReference>> eq ? and <<Location>> eq ?  and <<TenantID>> eq ?)&param0=${bookingNumber}&param1=${LocationNumber}&param2=${agentInfo.TenantId}`;
                    if (agentTypefromLocal == 'SQL') {
                        headers.Options = 'TopN|1|CrossTenantQuery|true|DocumentAttachment.OrderBy|Order By <<DocumentAttachment.AddDateTime>>';
                        url = `${gatewayURL}/RESTActivityWebService/agris.relational/DocumentAttachment?where=( <<DocumentReference>> eq ? and <<Location>> eq ?  and <<TenantID>> eq ?)&param0=${bookingNumber}&param1=${LocationNumber}&param2=${agentInfo.TenantId}`;
                    }
                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getDocumentAttachmentInfo(bookingNumber, LocationNumber));
                    })
                }
            });
        });
    }
}
